import Router from 'vue-router'
import router from '@/router'
import staticRouter from './staticRouter'//静态路由
export function resetRouter() {
  const newRouter = new Router({
    routes: staticRouter
  });
  router.matcher = newRouter.matcher;
}


// WEBPACK FOOTER //
// ./src/router/resetRouter.js